export default __webpack_public_path__ + "static/media/fmcgCase.e517cd31.jpg";